module.exports = __webpack_public_path__ + "img/contact.0866e8c9.svg";